<template>
  <div class="create_page" @click="handleClickOutside">
    <div class="css3 questionnaire_box">
      <AddControl
        :questionType="1"
        @importClick="handleImportClick"
        @componentClick="handleComponentClick"
      ></AddControl>
      <div
        class="box-sizing add_content"
        style="
          width: 630px;
          overflow-y: auto;
          height: 100%;
          position: relative;
          padding-bottom: 80px;
        "
      >
        <div class="create_head">
          <EditHeader
            :dataObj="dataObj"
            :modules="moduleList"
            :uuid="uuid"
            @change="handleInfoChange"
            ref="editHeader"
          ></EditHeader>
        </div>
        <div class="subject_list">
          <div class="noData" v-if="addQuestionsList.length <= 0">
            <img
              src="https://ossfastmake.mustke.com/qrCode/tupian/1749797144252.png"
              alt=""
            />
            <div class="text">请点击左侧题型</div>
          </div>

          <div
            v-for="(item, index) in addQuestionsList"
            :key="index"
            @click.stop=""
          >
            <div class="item" v-if="item.type == QuestionType.SCQ">
              <div v-if="item.status === '0'">
                <QuestionEditSCQ
                  :params="item"
                  :index="index"
                  :uuid="uuid"
                  :allDatas="addQuestionsList"
                  :isPage="dataObj.isPage"
                  :ifRandomOrder="dataObj.ifRandomOrder"
                  @save="saveQuestionClick"
                  @operate="handleOperateClick"
                  @update="updateQuestionClick"
                  @cancel="cancelQuestionClick"
                  @logic="logicSettingClick(item, index)"
                  @promptConfirm="handleLogicIntercept"
                ></QuestionEditSCQ>
              </div>
              <div v-else style="position: relative">
                <QuestionPreviewSCQ
                  :params="{ data: item, index: index }"
                ></QuestionPreviewSCQ>
                <div
                  class="mask-div"
                  @click.stop="handleMaskClick(index)"
                ></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.MCQ">
              <div v-if="item.status === '0'">
                <QuestionEditMCQ
                  :params="item"
                  :index="index"
                  :uuid="uuid"
                  @save="saveQuestionClick"
                  @operate="handleOperateClick"
                  @update="updateQuestionClick"
                  @cancel="cancelQuestionClick"
                  @logic="logicSettingClick(item, index)"
                ></QuestionEditMCQ>
              </div>
              <div v-else style="position: relative">
                <QuestionPreviewMCQ
                  :params="{ data: item, index: index }"
                ></QuestionPreviewMCQ>
                <div
                  class="mask-div"
                  @click.stop="handleMaskClick(index)"
                ></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.SBQ">
              <div v-if="item.status === '0'">
                <QuestionEditSBQ
                  :params="item"
                  :index="index"
                  :uuid="uuid"
                  @save="saveQuestionClick"
                  @operate="handleOperateClick"
                  @update="updateQuestionClick"
                  @cancel="cancelQuestionClick"
                  @logic="logicSettingClick(item, index)"
                ></QuestionEditSBQ>
              </div>
              <div v-else style="position: relative">
                <QuestionPreviewSBQ
                  :params="{ data: item, index: index }"
                ></QuestionPreviewSBQ>
                <div
                  class="mask-div"
                  @click.stop="handleMaskClick(index)"
                ></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.MBQ">
              <div v-if="item.status === '0'">
                <QuestionEditMBQ
                  :params="item"
                  :index="index"
                  :uuid="uuid"
                  @save="saveQuestionClick"
                  @operate="handleOperateClick"
                  @update="updateQuestionClick"
                  @cancel="cancelQuestionClick"
                  @logic="logicSettingClick(item, index)"
                ></QuestionEditMBQ>
              </div>
              <div v-else style="position: relative">
                <QuestionPreviewMBQ
                  :params="{ data: item, index: index }"
                ></QuestionPreviewMBQ>
                <div
                  class="mask-div"
                  @click.stop="handleMaskClick(index)"
                ></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.DLQ">
              <div v-if="item.status === '0'">
                <QuestionEditDLQ
                  :params="item"
                  :index="index"
                  :uuid="uuid"
                  @save="saveQuestionClick"
                  @operate="handleOperateClick"
                  @update="updateQuestionClick"
                  @cancel="cancelQuestionClick"
                  @logic="logicSettingClick(item, index)"
                ></QuestionEditDLQ>
              </div>
              <div v-else style="position: relative">
                <QuestionPreviewDLQ
                  :params="{ data: item, index: index }"
                ></QuestionPreviewDLQ>
                <div
                  class="mask-div"
                  @click.stop="handleMaskClick(index)"
                ></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.NPS">
              <div v-if="item.status === '0'">
                <QuestionEditNPS
                  :params="item"
                  :index="index"
                  :uuid="uuid"
                  @save="saveQuestionClick"
                  @operate="handleOperateClick"
                  @update="updateQuestionClick"
                  @cancel="cancelQuestionClick"
                  @logic="logicSettingClick(item, index)"
                ></QuestionEditNPS>
              </div>
              <div v-else style="position: relative">
                <QuestionPreviewNPS
                  :params="{ data: item, index: index }"
                ></QuestionPreviewNPS>
                <div
                  class="mask-div"
                  @click.stop="handleMaskClick(index)"
                ></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.QA">
              <div v-if="item.status === '0'">
                <QuestionEditQA
                  :params="item"
                  :index="index"
                  :uuid="uuid"
                  @save="saveQuestionClick"
                  @operate="handleOperateClick"
                  @update="updateQuestionClick"
                  @cancel="cancelQuestionClick"
                  @logic="logicSettingClick(item, index)"
                ></QuestionEditQA>
              </div>
              <div v-else style="position: relative">
                <QuestionPreviewQA
                  :params="{ data: item, index: index }"
                ></QuestionPreviewQA>
                <div
                  class="mask-div"
                  @click.stop="handleMaskClick(index)"
                ></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.SRQ">
              <div v-if="item.status === '0'">
                <QuestionEditSRQ
                  :params="item"
                  :index="index"
                  :uuid="uuid"
                  @save="saveQuestionClick"
                  @operate="handleOperateClick"
                  @update="updateQuestionClick"
                  @cancel="cancelQuestionClick"
                  @logic="logicSettingClick(item, index)"
                ></QuestionEditSRQ>
              </div>
              <div v-else style="position: relative">
                <QuestionPreviewSRQ
                  :params="{ data: item, index: index }"
                ></QuestionPreviewSRQ>
                <div
                  class="mask-div"
                  @click.stop="handleMaskClick(index)"
                ></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.VOTE">
              <div v-if="item.status === '0'">
                <QuestionEditVote
                  :params="item"
                  :index="index"
                  :uuid="uuid"
                  @save="saveQuestionClick"
                  @operate="handleOperateClick"
                  @update="updateQuestionClick"
                  @cancel="cancelQuestionClick"
                  @logic="logicSettingClick(item, index)"
                ></QuestionEditVote>
              </div>
              <div v-else style="position: relative">
                <QuestionPreviewVote
                  :params="{ data: item, index: index }"
                ></QuestionPreviewVote>
                <div
                  class="mask-div"
                  @click.stop="handleMaskClick(index)"
                ></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.SORT">
              <div v-if="item.status === '0'">
                <QuestionEditSort
                  :params="item"
                  :index="index"
                  :uuid="uuid"
                  @save="saveQuestionClick"
                  @operate="handleOperateClick"
                  @update="updateQuestionClick"
                  @cancel="cancelQuestionClick"
                  @logic="logicSettingClick(item, index)"
                ></QuestionEditSort>
              </div>
              <div v-else style="position: relative">
                <QuestionPreviewSort
                  :params="{ data: item, index: index }"
                ></QuestionPreviewSort>
                <div
                  class="mask-div"
                  @click.stop="handleMaskClick(index)"
                ></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.SCORE">
              <div v-if="item.status === '0'">
                <QuestionEditScore
                  :params="item"
                  :index="index"
                  :uuid="uuid"
                  @save="saveQuestionClick"
                  @operate="handleOperateClick"
                  @update="updateQuestionClick"
                  @cancel="cancelQuestionClick"
                  @logic="logicSettingClick(item, index)"
                ></QuestionEditScore>
              </div>
              <div v-else style="position: relative">
                <QuestionPreviewScore
                  :params="{ data: item, index: index }"
                ></QuestionPreviewScore>
                <div
                  class="mask-div"
                  @click.stop="handleMaskClick(index)"
                ></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.WRQ">
              <div v-if="item.status === '0'">
                <QuestionEditWRQ
                  :params="item"
                  :index="index"
                  :uuid="uuid"
                  @save="saveQuestionClick"
                  @operate="handleOperateClick"
                  @update="updateQuestionClick"
                  @cancel="cancelQuestionClick"
                  @logic="logicSettingClick(item, index)"
                ></QuestionEditWRQ>
              </div>
              <div v-else style="position: relative">
                <QuestionPreviewWRQ
                  :params="{ data: item, index: index }"
                ></QuestionPreviewWRQ>
                <div
                  class="mask-div"
                  @click.stop="handleMaskClick(index)"
                ></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.REMARK">
              <div v-if="item.status === '0'">
                <QuestionEditRemark
                  :params="item"
                  :index="index"
                  :uuid="uuid"
                  @save="saveQuestionClick"
                  @operate="handleOperateClick"
                  @update="updateQuestionClick"
                  @cancel="cancelQuestionClick"
                  @logic="logicSettingClick(item, index)"
                ></QuestionEditRemark>
              </div>
              <div v-else style="position: relative">
                <QuestionPreviewRemark
                  :params="{ data: item, index: index }"
                ></QuestionPreviewRemark>
                <div
                  class="mask-div"
                  @click.stop="handleMaskClick(index)"
                ></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.NAME">
              <div v-if="item.status === '0'">
                <QuestionEditName
                  :params="item"
                  :index="index"
                  @save="saveQuestionClick"
                  @operate="handleOperateClick"
                  @update="updateQuestionClick"
                  @cancel="cancelQuestionClick"
                  @logic="logicSettingClick(item, index)"
                ></QuestionEditName>
              </div>
              <div v-else style="position: relative">
                <QuestionPreviewName
                  :params="{ data: item, index: index }"
                ></QuestionPreviewName>
                <div
                  class="mask-div"
                  @click.stop="handleMaskClick(index)"
                ></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.GENDER">
              <div v-if="item.status === '0'">
                <QuestionEditGender
                  :params="item"
                  :index="index"
                  @save="saveQuestionClick"
                  @operate="handleOperateClick"
                  @update="updateQuestionClick"
                  @cancel="cancelQuestionClick"
                  @logic="logicSettingClick(item, index)"
                ></QuestionEditGender>
              </div>
              <div v-else style="position: relative">
                <QuestionPreviewGender
                  :params="{ data: item, index: index }"
                ></QuestionPreviewGender>
                <div
                  class="mask-div"
                  @click.stop="handleMaskClick(index)"
                ></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.AGE">
              <div v-if="item.status === '0'">
                <QuestionEditAge
                  :params="item"
                  :index="index"
                  @save="saveQuestionClick"
                  @operate="handleOperateClick"
                  @update="updateQuestionClick"
                  @cancel="cancelQuestionClick"
                  @logic="logicSettingClick(item, index)"
                ></QuestionEditAge>
              </div>
              <div v-else style="position: relative">
                <QuestionPreviewAge
                  :params="{ data: item, index: index }"
                ></QuestionPreviewAge>
                <div
                  class="mask-div"
                  @click.stop="handleMaskClick(index)"
                ></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.TEL">
              <div v-if="item.status === '0'">
                <QuestionEditTel
                  :params="item"
                  :index="index"
                  @save="saveQuestionClick"
                  @operate="handleOperateClick"
                  @update="updateQuestionClick"
                  @cancel="cancelQuestionClick"
                  @logic="logicSettingClick(item, index)"
                ></QuestionEditTel>
              </div>
              <div v-else style="position: relative">
                <QuestionPreviewTel
                  :params="{ data: item, index: index }"
                ></QuestionPreviewTel>
                <div
                  class="mask-div"
                  @click.stop="handleMaskClick(index)"
                ></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.EMAIL">
              <div v-if="item.status === '0'">
                <QuestionEditEmail
                  :params="item"
                  :index="index"
                  @save="saveQuestionClick"
                  @operate="handleOperateClick"
                  @update="updateQuestionClick"
                  @cancel="cancelQuestionClick"
                  @logic="logicSettingClick(item, index)"
                ></QuestionEditEmail>
              </div>
              <div v-else style="position: relative">
                <QuestionPreviewEmail
                  :params="{ data: item, index: index }"
                ></QuestionPreviewEmail>
                <div
                  class="mask-div"
                  @click.stop="handleMaskClick(index)"
                ></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.DATE">
              <div v-if="item.status === '0'">
                <QuestionEditDate
                  :params="item"
                  :index="index"
                  @save="saveQuestionClick"
                  @operate="handleOperateClick"
                  @update="updateQuestionClick"
                  @cancel="cancelQuestionClick"
                  @logic="logicSettingClick(item, index)"
                ></QuestionEditDate>
              </div>
              <div v-else style="position: relative">
                <QuestionPreviewDate
                  :params="{ data: item, index: index }"
                ></QuestionPreviewDate>
                <div
                  class="mask-div"
                  @click.stop="handleMaskClick(index)"
                ></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.TIME">
              <div v-if="item.status === '0'">
                <QuestionEditTime
                  :params="item"
                  :index="index"
                  @save="saveQuestionClick"
                  @operate="handleOperateClick"
                  @update="updateQuestionClick"
                  @cancel="cancelQuestionClick"
                  @logic="logicSettingClick(item, index)"
                ></QuestionEditTime>
              </div>
              <div v-else style="position: relative">
                <QuestionPreviewTime
                  :params="{ data: item, index: index }"
                ></QuestionPreviewTime>
                <div
                  class="mask-div"
                  @click.stop="handleMaskClick(index)"
                ></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.ADDR">
              <div v-if="item.status === '0'">
                <QuestionEditAddress
                  :params="item"
                  :index="index"
                  @save="saveQuestionClick"
                  @operate="handleOperateClick"
                  @update="updateQuestionClick"
                  @cancel="cancelQuestionClick"
                  @logic="logicSettingClick(item, index)"
                ></QuestionEditAddress>
              </div>
              <div v-else style="position: relative">
                <QuestionPreviewAddress
                  :params="{ data: item, index: index }"
                ></QuestionPreviewAddress>
                <div
                  class="mask-div"
                  @click.stop="handleMaskClick(index)"
                ></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.IMAGE">
              <div v-if="item.status === '0'">
                <QuestionEditImage
                  :params="item"
                  :index="index"
                  :uuid="uuid"
                  @save="saveQuestionClick"
                  @operate="handleOperateClick"
                  @update="updateQuestionClick"
                  @cancel="cancelQuestionClick"
                  @logic="logicSettingClick(item, index)"
                ></QuestionEditImage>
              </div>
              <div v-else style="position: relative">
                <QuestionPreviewImage
                  :params="{ data: item, index: index }"
                ></QuestionPreviewImage>
                <div
                  class="mask-div"
                  @click.stop="handleMaskClick(index)"
                ></div>
              </div>
            </div>

            <div class="item" v-if="item.type == QuestionType.MaxDiff">
              <div v-if="item.status === '0'">
                <QuestionEditMaxDiff
                  :params="item"
                  :index="index"
                  :uuid="uuid"
                  @save="saveQuestionClick"
                  @operate="handleOperateClick"
                  @update="updateQuestionClick"
                  @cancel="cancelQuestionClick"
                  @logic="logicSettingClick(item, index)"
                ></QuestionEditMaxDiff>
              </div>
              <div v-else style="position: relative">
                <QuestionPreviewMaxDiff
                  :params="{ data: item, index: index }"
                ></QuestionPreviewMaxDiff>
                <div
                  class="mask-div"
                  @click.stop="handleMaskClick(index)"
                ></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.UploadFile">
              <div v-if="item.status === '0'">
                <QuestionEditUploadFile
                  :params="item"
                  :index="index"
                  :uuid="uuid"
                  @save="saveQuestionClick"
                  @operate="handleOperateClick"
                  @update="updateQuestionClick"
                  @cancel="cancelQuestionClick"
                  @logic="logicSettingClick(item, index)"
                ></QuestionEditUploadFile>
              </div>
              <div v-else style="position: relative">
                <QuestionPreviewUploadFile
                  :params="{ data: item, index: index }"
                ></QuestionPreviewUploadFile>
                <div
                  class="mask-div"
                  @click.stop="handleMaskClick(index)"
                ></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.DownloadFile">
              <div v-if="item.status === '0'">
                <QuestionEditDownloadFile
                  :params="item"
                  :index="index"
                  :uuid="uuid"
                  @save="saveQuestionClick"
                  @operate="handleOperateClick"
                  @update="updateQuestionClick"
                  @cancel="cancelQuestionClick"
                  @logic="logicSettingClick(item, index)"
                ></QuestionEditDownloadFile>
              </div>
              <div v-else style="position: relative">
                <QuestionPreviewDownloadFile
                  :params="{ data: item, index: index }"
                ></QuestionPreviewDownloadFile>
                <div
                  class="mask-div"
                  @click.stop="handleMaskClick(index)"
                ></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.CASCADER">
              <div v-if="item.status === '0'">
                <QuestionEditCASCADER
                  :params="item"
                  :index="index"
                  :uuid="uuid"
                  @save="saveQuestionClick"
                  @operate="handleOperateClick"
                  @update="updateQuestionClick"
                  @cancel="cancelQuestionClick"
                  @logic="logicSettingClick(item, index)"
                ></QuestionEditCASCADER>
              </div>
              <div v-else style="position: relative">
                <QuestionPreviewCASCADER
                  :params="{ data: item, index: index }"
                ></QuestionPreviewCASCADER>
                <div
                  class="mask-div"
                  @click.stop="handleMaskClick(index)"
                ></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.BDQ">
              <div v-if="item.status === '0'">
                <QuestionEditBDQ
                  :params="item"
                  :index="index"
                  :uuid="uuid"
                  @save="saveQuestionClick"
                  @operate="handleOperateClick"
                  @update="updateQuestionClick"
                  @cancel="cancelQuestionClick"
                  @logic="logicSettingClick(item, index)"
                ></QuestionEditBDQ>
              </div>
              <div v-else style="position: relative">
                <QuestionPreviewBDQ
                  :params="{ data: item, index: index }"
                ></QuestionPreviewBDQ>
                <div
                  class="mask-div"
                  @click.stop="handleMaskClick(index)"
                ></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.IDQ">
              <div v-if="item.status === '0'">
                <QuestionEditIDQ
                  :params="item"
                  :index="index"
                  :uuid="uuid"
                  @save="saveQuestionClick"
                  @operate="handleOperateClick"
                  @update="updateQuestionClick"
                  @cancel="cancelQuestionClick"
                  @logic="logicSettingClick(item, index)"
                ></QuestionEditIDQ>
              </div>
              <div v-else style="position: relative">
                <QuestionPreviewIDQ
                  :params="{ data: item, index: index }"
                ></QuestionPreviewIDQ>
                <div
                  class="mask-div"
                  @click.stop="handleMaskClick(index)"
                ></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.ELQ">
              <div v-if="item.status === '0'">
                <QuestionEditELQ
                  :params="item"
                  :index="index"
                  :uuid="uuid"
                  @save="saveQuestionClick"
                  @operate="handleOperateClick"
                  @update="updateQuestionClick"
                  @cancel="cancelQuestionClick"
                  @logic="logicSettingClick(item, index)"
                ></QuestionEditELQ>
              </div>
              <div v-else style="position: relative">
                <QuestionPreviewELQ
                  :params="{ data: item, index: index }"
                ></QuestionPreviewELQ>
                <div
                  class="mask-div"
                  @click.stop="handleMaskClick(index)"
                ></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.WX">
              <div v-if="item.status === '0'">
                <QuestionEditWX
                  :params="item"
                  :index="index"
                  :uuid="uuid"
                  @save="saveQuestionClick"
                  @operate="handleOperateClick"
                  @update="updateQuestionClick"
                  @cancel="cancelQuestionClick"
                  @logic="logicSettingClick(item, index)"
                ></QuestionEditWX>
              </div>
              <div v-else style="position: relative">
                <QuestionPreviewWX
                  :params="{ data: item, index: index }"
                ></QuestionPreviewWX>
                <div
                  class="mask-div"
                  @click.stop="handleMaskClick(index)"
                ></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.TITLE">
              <div v-if="item.status === '0'">
                <QuestionEditTitle
                  :params="item"
                  :index="index"
                  :uuid="uuid"
                  @save="saveQuestionClick"
                  @operate="handleOperateClick"
                  @update="updateQuestionClick"
                  @cancel="cancelQuestionClick"
                  @logic="logicSettingClick(item, index)"
                ></QuestionEditTitle>
              </div>
              <div v-else style="position: relative">
                <QuestionPreviewTitle
                  :params="{ data: item, index: index }"
                ></QuestionPreviewTitle>
                <div
                  class="mask-div"
                  @click.stop="handleMaskClick(index)"
                ></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.ImageSCQ">
              <div v-if="item.status === '0'">
                <QuestionEditImageScq
                  :params="item"
                  :index="index"
                  :uuid="uuid"
                  @save="saveQuestionClick"
                  @operate="handleOperateClick"
                  @update="updateQuestionClick"
                  @cancel="cancelQuestionClick"
                  @logic="logicSettingClick(item, index)"
                ></QuestionEditImageScq>
              </div>
              <div v-else style="position: relative">
                <QuestionPreviewImageScq
                  :params="{ data: item, index: index }"
                ></QuestionPreviewImageScq>
                <div
                  class="mask-div"
                  @click.stop="handleMaskClick(index)"
                ></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.ImageMCQ">
              <div v-if="item.status === '0'">
                <QuestionEditImageMcq
                  :params="item"
                  :index="index"
                  :uuid="uuid"
                  @save="saveQuestionClick"
                  @operate="handleOperateClick"
                  @update="updateQuestionClick"
                  @cancel="cancelQuestionClick"
                  @logic="logicSettingClick(item, index)"
                ></QuestionEditImageMcq>
              </div>
              <div v-else style="position: relative">
                <QuestionPreviewImageMcq
                  :params="{ data: item, index: index }"
                ></QuestionPreviewImageMcq>
                <div
                  class="mask-div"
                  @click.stop="handleMaskClick(index)"
                ></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.MatrixSCQ">
              <div v-if="item.status === '0'">
                <QuestionEditMatrixScq
                  :params="item"
                  :index="index"
                  :uuid="uuid"
                  @save="saveQuestionClick"
                  @operate="handleOperateClick"
                  @update="updateQuestionClick"
                  @cancel="cancelQuestionClick"
                  @logic="logicSettingClick(item, index)"
                ></QuestionEditMatrixScq>
              </div>
              <div v-else style="position: relative">
                <QuestionPreviewMatrixScq
                  :params="{ data: item, index: index }"
                ></QuestionPreviewMatrixScq>
                <div
                  class="mask-div"
                  @click.stop="handleMaskClick(index)"
                ></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.MatrixMCQ">
              <div v-if="item.status === '0'">
                <QuestionEditMatrixMcq
                  :params="item"
                  :index="index"
                  :uuid="uuid"
                  @save="saveQuestionClick"
                  @operate="handleOperateClick"
                  @update="updateQuestionClick"
                  @cancel="cancelQuestionClick"
                  @logic="logicSettingClick(item, index)"
                ></QuestionEditMatrixMcq>
              </div>
              <div v-else style="position: relative">
                <QuestionPreviewMatrixMcq
                  :params="{ data: item, index: index }"
                ></QuestionPreviewMatrixMcq>
                <div
                  class="mask-div"
                  @click.stop="handleMaskClick(index)"
                ></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.ImageOrVideo">
              <div v-if="item.status === '0'">
                <QuestionEditImageOrVideo
                  :params="item"
                  :index="index"
                  :uuid="uuid"
                  @save="saveQuestionClick"
                  @operate="handleOperateClick"
                  @update="updateQuestionClick"
                  @cancel="cancelQuestionClick"
                  @logic="logicSettingClick(item, index)"
                ></QuestionEditImageOrVideo>
              </div>
              <div v-else style="position: relative">
                <QuestionPreviewImageOrVideo
                  :params="{ data: item, index: index }"
                ></QuestionPreviewImageOrVideo>
                <div
                  class="mask-div"
                  @click.stop="handleMaskClick(index)"
                ></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.Signature">
              <div v-if="item.status === '0'">
                <QuestionEditSignature
                  :params="item"
                  :index="index"
                  :uuid="uuid"
                  @save="saveQuestionClick"
                  @operate="handleOperateClick"
                  @update="updateQuestionClick"
                  @cancel="cancelQuestionClick"
                  @logic="logicSettingClick(item, index)"
                ></QuestionEditSignature>
              </div>
              <div v-else style="position: relative">
                <QuestionPreviewSignature
                  :params="{ data: item, index: index }"
                ></QuestionPreviewSignature>
                <div
                  class="mask-div"
                  @click.stop="handleMaskClick(index)"
                ></div>
              </div>
            </div>
            <div class="item" v-if="item.type == QuestionType.PageBreak">
              <div v-if="item.status === '0'">
                <QuestionEditPageBreak
                  :params="item"
                  :index="index"
                  :uuid="uuid"
                  @save="saveQuestionClick"
                  @operate="handleOperateClick"
                  @update="updateQuestionClick"
                  @cancel="cancelQuestionClick"
                  @logic="logicSettingClick(item, index)"
                ></QuestionEditPageBreak>
              </div>
              <div v-else style="position: relative">
                <QuestionPreviewPageBreak
                  :params="{ data: item, index: index }"
                ></QuestionPreviewPageBreak>
                <div
                  class="mask-div"
                  @click.stop="handleMaskClick(index)"
                ></div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="bottom"
          style="position: fixed; bottom: 10px; width: 630px; z-index: 91"
        >
          <!-- <div>
            <div class="cy_text">
              <div class="cy_text_show">问卷到此结束，感谢您的参与！</div>
            </div>
          </div> -->
          <button
            type="button"
            class="el-button hold el-button--primary el-button--medium"
            @click.stop="createClick(0)"
            style="
              width: 132px;
              height: 40px;
              background: #ffffff;
              border: 1px solid #3a60ff;
              color: #3a60ff;
            "
          >
            <span>保存草稿</span>
          </button>
          <button
            type="button"
            class="el-button hold el-button--primary el-button--medium"
            @click.stop="createClick(1)"
            style="
              width: 132px;
              height: 40px;
              background: #3a60ff;
              border: 1px solid #3a60ff;
            "
          >
            <span>生成问卷</span>
          </button>
        </div>
      </div>
      <!-- 设置 -->
      <EditSetting
        :params="dataObj"
        :uuid="uuid"
        :type="1"
        :dataList="addQuestionsList"
        @change="handleSettingChange"
        @showMessage="handleShowMessage"
      ></EditSetting>
    </div>
    <div class="drawer-container">
      <LibraryChooseDialog
        :showDialog.sync="showDialog"
        :uuid="uuid"
        :libraryType="'1'"
        @confirm="handleConfirmClick"
        @import="handleImportAllClick"
        @close="showDialog = false"
      ></LibraryChooseDialog>
    </div>
    <input
      type="file"
      ref="uploadImage"
      accept="image/*"
      multiple
      limit="2"
      style="display: none"
      @change="handleImageFileChange"
    />
    <input
      type="file"
      ref="uploadVideo"
      accept="video/*"
      style="display: none"
      @change="handleVideoFileChange"
    />

    <!-- 微信绑定弹窗 -->
    <el-dialog
      title="绑定微信"
      :visible.sync="wxBindDialogVisible"
      width="400px"
      center
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <div class="wx-bind-dialog">
        <p>请扫码绑定微信后继续</p>
        <div class="qr-code-container">
          <img
            ref="xcxqrcode"
            :src="qrCodeUrl"
            alt="微信二维码"
            v-if="qrCodeUrl"
          />
          <div v-else class="loading">加载中...</div>
        </div>
        <p class="message">{{ message }}</p>
        <div ref="wrpreloadbtn" class="reload-btn" v-if="message">
          <el-button type="primary" size="small" @click="getWxQrCode"
            >重新获取</el-button
          >
        </div>
      </div>
    </el-dialog>
	
	<div class="againModify" v-if="againModifyShow" @click="againModifyShow = false, againModifyState = false">
		<div class="content" @click.stop>
			<div class="heading">
				请选择修改方式
				<div class="icon" @click="againModifyShow = false, againModifyState = false"></div>
			</div>
			<div class="list">
				<div class="item" v-for="(item,index) in againModifyList" :ket="index" :class="{ active: againModifyActive === index }" @click="againModifyActive = index">
					<div class="title">{{ item.title }}</div>
					<div class="text">{{ item.text }}</div>
				</div>
			</div>
			<div class="button">
				<div class="item" @click="againModifyShow = false, againModifyState = false">取消</div>
				<div class="item" @click="againModifyCofim">确定</div>
			</div>
		</div>
	</div>
  </div>
</template>
<script>
import axios from "axios";
import baseURL from "../../utils/bsaeUrl";

import EditHeader from "@/components/EditHeader/EditHeader.vue";
import AddControl from "@/components/AddControl/index.vue";
import EditSetting from "@/components/EditSetting/index.vue";
import LibraryChooseDialog from "@/components/LibraryChooseDialog/index.vue";

import { EditComponents, PreviewComponents } from "@/utils/componentImports.js";

import {
  getUuid,
  createQuestionnaire,
  updateQuestionnaire,
  setQuestion,
  questionTempList,
  questionnaireUpdateDetail,
  removeQuestionnaire,
  saveQuestion,
  getThemeList,
  addQuestionToQuestionnaire,
  feiShuBindUser,
  updateQuestionnaireSetting
} from "@/api/index.js";

export default {
  components: {
    ...EditComponents,
    ...PreviewComponents,
    LibraryChooseDialog,
    EditHeader,
    AddControl,
    EditSetting,
  },
  data() {
    return {
      uuid: "",
      QuestionType: this.$store.getters["questionType/getQuestionType"],
      formItems: [],
      selectedIndex: null,
      // 微信绑定弹窗相关
      wxBindDialogVisible: false,
      qrCodeUrl: "",
      loginKey: "",
      pollingInterval: null,
      message: "",
      token: "",
      dataObj: {
        questionnaireType: "1",
        questionnaireName: "", // 问卷名称
        questionnaireDescribe: "", // 问卷描述
        questionnaireInformation: JSON.stringify([]), // 问卷信息
        ifFrontPage: 0, //  是否开始答题/问卷结束设置 0不设置 1设置
        startLanguage: "感谢您的参与", // 问卷开始语
        endLanguage: "感谢您的参与", // 问卷结束语
        endImg:
          "https://ossfastmake.mustke.com/qrCode/tupian/1737534281905.png", // 问卷结束图片
        startImg:
          "https://ossfastmake.mustke.com/qrCode/tupian/1737534281905.png", // 问卷开始图片
        startSubtitle: "", // 问卷开始小标题
        startButtonText: "开始答题", // 问卷开始按钮文本
        startButtonColor: "#FF4F4F", // 问卷开始按钮颜色
        startColor: "#1D4AC3", // 问卷开始主题颜色
        endColor: "#1D4AC3", // 问卷结束主题颜色
        startLittleImg: "", // 问卷开始小图片
        endLittleImg: "", // 问卷结束小图片
        startColorBegin: "", // 问卷开始主题颜色
        endColorBegin: "", // 问卷结束主题颜色
        startColorEnd: "", // 问卷开始主题颜色
        endColorEnd: "", // 问卷结束主题颜色
        startThemeColor: "", // 问卷开始主题颜色
        endThemeColor: "", // 问卷结束主题颜色
        startTextColor: "", // 问卷开始文本颜色
        endTextColor: "", // 问卷结束文本颜色
        ifOneChance: "1", // 每人只能回答一次(仅限小程序生效) 0不设置 1设置
        ifShowCreator: "0", // 显示创建者 0不设置 1设置
        ifShowParticipation: "0", // 显示参与人数 0不设置 1设置
        ifShowCreateTime: "0", // 显示创建时间 0不设置 1设置
        ifRecyclingReminder: "0", // 问卷回收题提醒 0不设置 1设置
        ifShare: "0", // 仅创建人可分享 0不设置 1设置
        ifAnonymous: "0", // 是否匿名 0不设置 1设置
        ifShowFooterLogo: "1", // 是否显示底部logo 0不显示 1显示
        ifAllowSwitchScreen: "0", // 是否允许切屏 0允许 1不允许
        allowSwitchScreenTimes: 1, // 允许切屏次数
        ifAnonymous: "0", // 匿名答题开关 0=关闭,1=开启
        ifRandomOrder: "0", // 题目随机顺序开关 0=关闭,1=开启
        ifViewContent: "0", // 是否可查看填写内容 0可以 1不可以
        ifFreeAd: "0", // 是否免广告 0不免广告 1免广告
        adLimitNum: "0", // 广告限制数
        isPage: 0, // 是否一页一题 0否 1是
        ifCover: "1", // 是否封面 0不设置 1设置
        coverUrl: "", // 封面图片
        creatorName: localStorage.getItem("nickname"), // 创建人
        themeId: "", // 主题id
        yzTheme: {
          borderColor: "#E3E3E3",
          startColor: "#ffffff",
          endColor: "#ffffff",
          mainTitle: "默认主题",
          subTitle: "默认主题",
          mainColor: "#333333",
          subColor: "#333333",
          btnColor: "#333333",
          btnText: "提交",
          btnBg: "#ffffff",
          btnBorder: "#E3E3E3",
          themeColor: "#3A60FF",
        }, // 主题数据
        ifForever: "0", // 是否设置开始时间结束时间  0否 1是
        startTime: new Date().getTime(), // 问卷开始时间
        endTime: new Date().getTime() + 7 * 24 * 60 * 60 * 1000, // 问卷结束时间
        ifCustomLogin: "0", // 是否设置自定义登录(独立登录) 0不设置 1设置
        ifRandomOrder: "0", // 是否随机排序 0不设置 1设置
        consentRequired: "0", // 知情同意书 0不设置 1设置
        ifMessageNotify: "0", // 是否短信通知 0不设置 1设置
        ifLimitAnswerNum: "0", // 是否控制提交答案总数 0不设置 1设置
        limitAnswerNum: "0", // 答案总数不超过
        ifRedirect: "0", // 是否开启跳转链接 0不开启 1开启
        redirectUrl: "", // 跳转url
        consentContent:
          "感谢您考虑参与我们的调查问卷。这份问卷旨在收集关于XXX主题的重要信息，以帮助我们更好地理解这一领域。您的参与对于我们的研究至关重要。在您开始之前，我们希望您了解以下事项:\n" +
          "1.目的与保密性: 此调查的目的在于收集关于XXX主题的数据。您的个人信息(包括姓名和联系方式)将严格保密，只用于统计分析，并在报告中以匿名方式星现。\n" +
          "2.自愿参与: 您的参与是完全自愿的。如果您在任何时候决定退出调查，都可以自由地停止回答问题,数据保护: 我们将采取所有必要的安全措施来保护您的个人信息。数据将被存储在受密码保护的系统中，并且只有经过授权的人员可以访问。",
        customLoginSettingList: [
          {
            type: 1, // 1题头 2头像 3填空 4下拉
            content: JSON.stringify({
              popTitle: "快速登录",
              popSmallTitle: "请正确填写下面信息",
            }),
          },
          {
            type: 2,
            content: JSON.stringify({
              headTitle: "头像",
              headSmallTitle: "点击上传头像",
              imageUrl:
                "https://ossfastmake.mustke.com/qrCode/tupian/1750303449766.svg",
            }),
          },
          {
            type: 3,
            content: JSON.stringify({
              label: "姓名",
              value: "",
              type: 0,
            }),
          },
        ],
        buildStatus: 0, // 生成状态 0保存草稿  1生成问卷
        shareImgId: null, // 分享图片id
        shareImgUrl:
          "https://ossfastmake.mustke.com/wenjuan/tupian/shareBack2-1744791138873.jpg", // 分享图片url
      },
      infoFileList: [],
      addQuestionsList: [],
      choiceOfId: "",
      /* 点击的是不是可编辑区域右上角的按钮 */
      isAbilityBtn: false,
      // 编辑器内的 图片定位
      positionInfo: {
        top: 100,
        left: 100,
        show: false,
      },
      // 是否显示选项按钮
      showOptionBtn: [1, 2, 12, 14, 15],
      // 是否显示其他选项按钮
      showOtherOptionBtn: [1, 2, 12, 14, 15],
      Starstyle_arr: ["五角星", "爱心", "笑脸", "点赞"],
      // 评分题数量设置 数组
      scoreArr: [2, 3, 4, 5, 6, 7, 8, 9, 10],
      // 评分题起始值设置 数组
      startScoreArr: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      Type: null,
      operate: "创建",
      id: null,
      loading: null,
      showThemeSetting: false,
      selectThemeIndex: 0,
      themeList: [],
      showCoverSetting: false,
      showLoginSetting: false,
      showConsentRequired: false,
      showShareImage: false,
      themeData: {},
      showDialog: false,
      uploadFileIndex: -1,
      nameFocus: false,
      descFocus: false,
      moduleList: [],
      isNext: false,
	  againModifyShow: false,
	  againModifyState: false,
	  againModifyActive: 0,
	  againModifyList: [{
		  title: '限制性修改',
		  text: '有限修改问卷，只能修改题目、文字、选项等，不会清空已收集样本数据。'
	  },{
		  title: '完全修改',
		  text: '可以修改或删除题目、题型等并清空已收集的样本数据。'
	  },
	  {
		  title: '复制该问卷',
		  text: '复制一份问卷，新的问卷与被复制的问卷完全相同，对复制的问卷进行编辑。'
	  }]
    };
  },
  mounted() {
    this.id = this.$route.query.id;
    if (this.id && this.id.trim() !== "") {
      if (this.$route.query.type === "template") {
        this.operate = "创建";
      } else {
        this.operate = "编辑";
      }
      this.uuid = this.id;
      localStorage.setItem("uuid", this.uuid);
      this.queryDetail();
    } else {
      this.getUuidParams();
    }

    this.queryQuestionTempList();

    console.log("QuestionType1111111111111", this.QuestionType);
  },
  created() {
    console.log("接收到的 ID：", this.$route.query.id);
    this.uuid = this.$route.query.id;
    this.dataObj.questionnaireName = this.$route.query.title
      ? this.$route.query.title
      : "";
    this.dataObj.questionnaireDescribe = this.$route.query.content
      ? this.$route.query.content
      : "";
    this.themeData = this.dataObj.yzTheme;
    getThemeList()
      .then((res) => {
        console.log(res, "pppppppppppppppppp");

        this.themeList = res.data;
      })
      .catch((err) => {
        console.log(err);
      });
    // 监听页面刷新或关闭事件
    window.addEventListener("beforeunload", this.beforeUnloadHandler);
  },
  beforeRouteLeave(to, from, next) {
    // this.showPromptPopup = true;

    if (this.isNext) {
      next();
    } else {
      if (this.addQuestionsList.length > 0) {
        this.$confirm("当前页面存在题型内容，是否保存该问卷？", "提示", {
          confirmButtonText: "确认保存",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            next(false);
            this.createClick(1);
          })
          .catch(() => {
            next();
          });
      } else {
        next();
      }
    }
  },
  beforeDestroy() {
    // 移除事件监听器
    window.removeEventListener("beforeunload", this.beforeUnloadHandler);
  },
  // 组件定义同方案一
  methods: {
    // 页面刷新或关闭前的处理
    beforeUnloadHandler(e) {
      console.log("beforeUnloadHandler", e);
    },
    async getUuidParams() {
      await getUuid()
        .then((res) => {
          if (res.code === 200) {
            this.uuid = res.data;
            localStorage.setItem("uuid", this.uuid);
          } else {
            this.$message.closeAll();
            this.$message({
              type: "error",
              message: res.message,
              offset: "150",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    saveClick(item, index) {
      this.queryQuestionTempList();
    },
    cancelClick() {},
    selectItem(index) {
      this.selectedIndex = index;
    },
    async handleComponentClick(item, index, dataItem) {
      // const hasEdit = this.addQuestionsList.some((item) => item.status === "0");
      // if (hasEdit) {
      //   this.$message.closeAll();
      //   this.$message({
      //     type: "error",
      //     message: "请先保存当前编辑的题目",
      //     offset: "150",
      //   });
      //   return;
      // }
      this.$message.closeAll();
      const activeItem = this.addQuestionsList.find(
        (item) => item.status === "0",
      );
      if (
        activeItem !== undefined &&
        activeItem !== null &&
        activeItem !== {}
      ) {
        const checkItem = this.checkQuestion(activeItem);
        if (checkItem) {
          checkItem.uuid = this.uuid;

          // 检查localStorage中是否存在openId
          const openId = localStorage.getItem("openId");
          if (
            openId == null ||
            openId == "null" ||
            openId == undefined ||
            openId == ""
          ) {
            if (this.wxBindDialogVisible == false) {
              // 显示微信绑定弹窗
              this.wxBindDialogVisible = true;
              // 获取二维码
              this.getWxQrCode();
            }

            return;
          }

          await saveQuestion(checkItem)
            .then((res) => {
              console.log(res);
              if (res.code == 200) {
                // this.queryQuestionTempList();
                activeItem.status = "1";
                this.$forceUpdate();
              } else {
                this.$message({
                  type: "error",
                  message: res.msg,
                  offset: "150",
                });
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          return false;
        }
      }
      if (item.type === this.QuestionType.PageBreak) {
        if (this.dataObj.isPage === 1) {
          this.$message.error("您已设置一页一题，将无法添加分页线！");
          return;
        }
        if (this.dataObj.ifRandomOrder === "1") {
          this.$message.error("您已设置题目随机排列，将无法添加分页线！");
          return;
        }
        if (this.addQuestionsList.length === 0) {
          this.$message.error("至少添加一个题目");
          return;
        }
        if (
          this.addQuestionsList[this.addQuestionsList.length - 1].type ===
          this.QuestionType.PageBreak
        ) {
          this.$message.error("分页线不能连续添加");
          return;
        }
        saveQuestion({
          uuid: this.uuid,
          type: this.QuestionType.PageBreak, // 分页
          caseProblem: "第1页",
          status: "0",
        }).then((res) => {
          if (res.code == 200) {
            this.queryQuestionTempList();
          } else {
            this.$message({
              type: "error",
              message: res.msg,
              offset: "150",
            });
          }
        });
      } else {
        const dataItem = await this.$store.dispatch(
          "moduleQuestionnaire/addQuestion",
          item.type,
        );
        this.addQuestionsList.push(dataItem);

        let pageLineIndex = 0;
        let questionIndex = 0;
        for (let i = 0; i < this.addQuestionsList.length; i++) {
          if (this.addQuestionsList[i].type === this.QuestionType.PageBreak) {
            pageLineIndex++;
            this.addQuestionsList[i].pageLineIndex = pageLineIndex;
          } else {
            if (this.addQuestionsList[i].type !== this.QuestionType.TITLE) {
              questionIndex++;
              this.addQuestionsList[i].questionIndex = questionIndex;
            }
          }
        }
      }
    },
    createClick(buildStatus) {
      // this.checkRequired()
      const activeItem = this.addQuestionsList.find(
        (item) => item.status === "0",
      );
      if (
        activeItem !== undefined &&
        activeItem !== null &&
        activeItem !== {}
      ) {
        this.$message.closeAll();
        const checkItem = this.checkQuestion(activeItem);
        if (checkItem) {
          checkItem.uuid = this.uuid;

          // 检查localStorage中是否存在openId
          const openId = localStorage.getItem("openId");
          if (
            openId == null ||
            openId == "null" ||
            openId == undefined ||
            openId == ""
          ) {
            if (this.wxBindDialogVisible == false) {
              // 显示微信绑定弹窗
              this.wxBindDialogVisible = true;
              // 获取二维码
              this.getWxQrCode();
            }

            return;
          }

          saveQuestion(checkItem)
            .then((res) => {
              console.log(res);
              if (res.code == 200) {
                // this.queryQuestionTempList();
                activeItem.status = "1";
                this.$forceUpdate();
              } else {
                this.$message({
                  type: "error",
                  message: res.msg,
                  offset: "150",
                });
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      }
      for (let i = 0; i < this.infoFileList.length; i++) {
        if (this.infoFileList[i].urls.length === 0) {
          this.$message.closeAll();
          this.$message({
            type: "error",
            message:
              this.infoFileList[i].type === 2 ? "请上传视频" : "请上传图片",
            offset: "150",
          });
          return;
        }
      }
      if (this.addQuestionsList.length === 0) {
        this.$message.closeAll();
        this.$message({
          type: "error",
          message: "请先添加考题后，在生成问卷！",
          offset: "150",
        });
        return;
      }
      // const hasEdit = this.addQuestionsList.some((item) => item.status === "1");
      // if (!hasEdit) {
      //   this.$message.closeAll();
      //   this.$message({
      //     type: "error",
      //     message: "请先保存编辑的题目",
      //     offset: "150",
      //   });
      //   return;
      // }
      const endTime = new Date(this.dataObj.endTime).getTime();
      const startTime = new Date(this.dataObj.startTime).getTime();

      if (this.dataObj.ifForever === "1") {
        console.log("1e21e21e212312312", endTime, startTime);
        if (startTime === 0 || startTime === "") {
          this.$message.closeAll();
          this.$message({
            type: "error",
            message: "请选择开始时间",
            offset: "150",
          });
          return;
        }
        if (endTime === 0 || endTime === "") {
          this.$message.closeAll();
          this.$message({
            type: "error",
            message: "请选择结束时间",
            offset: "150",
          });
          return;
        }
        if (endTime <= startTime) {
          this.$message.closeAll();
          this.$message({
            type: "error",
            message: "结束时间不能小于开始时间",
            offset: "150",
          });
          return;
        }
      }

      this.dataObj.customLoginSettingList =
        this.dataObj.customLoginSettingList.map((item) => {
          if (typeof item.content != "string") {
            item.content = JSON.stringify(item.content);
          }
          return item;
        });

      const modules = this.$refs.editHeader.getModuleList();
      if (modules === null) {
        return;
      }

      this.loading = this.$loading({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      if (this.operate === "创建") {
        createQuestionnaire({
          uuid: this.uuid, // 活动唯一标识
          questionnaireName:
            this.dataObj.questionnaireName.trim() === ""
              ? "问卷标题"
              : this.dataObj.questionnaireName, // 问卷名称
          questionnaireDescribe:
            this.dataObj.questionnaireDescribe.trim() === ""
              ? "感谢您抽出宝贵时间，您的回答意义重大！"
              : this.dataObj.questionnaireDescribe, // 问卷描述
          questionnaireInformation: JSON.stringify(this.infoFileList), // 问卷信息
          ifFrontPage: this.dataObj.ifFrontPage, //  是否开始答题/问卷结束设置 0不设置 1设置
          startLanguage: this.dataObj.startLanguage, // 问卷开始语
          endLanguage: this.dataObj.endLanguage, // 问卷结束语
          endImg: this.dataObj.endImg, // 问卷结束图片
          endSubtitle: this.dataObj.endSubtitle, // 问卷结束小标题
          startImg: this.dataObj.startImg, // 问卷开始图片
          startSubtitle: this.dataObj.startSubtitle, // 问卷开始小标题
          startButtonText: this.dataObj.startButtonText, // 问卷开始按钮文本
          startButtonColor: this.dataObj.startButtonColor, // 问卷开始按钮颜色
          startColor: this.dataObj.startColor, // 问卷开始主题颜色
          endColor: this.dataObj.endColor, // 问卷结束主题颜色
          startLittleImg: this.dataObj.startLittleImg, // 问卷开始小图
          endLittleImg: this.dataObj.endLittleImg, // 问卷结束小图
          startColorBegin: this.dataObj.startColorBegin,
          startColorEnd: this.dataObj.startColorEnd,
          startThemeColor: this.dataObj.startThemeColor,
          startTextColor: this.dataObj.startTextColor,
          endColorBegin: this.dataObj.endColorBegin,
          endColorEnd: this.dataObj.endColorEnd,
          endThemeColor: this.dataObj.endThemeColor,
          endTextColor: this.dataObj.endTextColor,
          ifOneChance: this.dataObj.ifOneChance, // 每人只能回答一次(仅限小程序生效) 0不设置 1设置
          ifShowCreator: this.dataObj.ifShowCreator, // 显示创建者 0不设置 1设置
          ifShowParticipation: this.dataObj.ifShowParticipation, // 显示参与人数 0不设置 1设置
          ifShowCreateTime: this.dataObj.ifShowCreateTime, // 显示创建时间 0不设置 1设置
          ifRecyclingReminder: this.dataObj.ifRecyclingReminder, // 问卷回收题提醒 0不设置 1设置
          themeId: this.dataObj.themeId, // 主题id
          yzTheme: this.dataObj.yzTheme, // 主题数据
          ifForever: this.dataObj.ifForever, // 问卷是否永久有效 0不设置 1设置,
          ifShare: this.dataObj.ifShare, // 是否分享 0不设置 1设置
          creatorName: this.dataObj.creatorName, // 创建者名称
          startTime: startTime === 0 || startTime === "" ? null : startTime, // 问卷开始时间
          endTime: endTime === 0 || endTime === "" ? null : endTime, // 问卷结束时间
          ifCustomLogin: this.dataObj.ifCustomLogin, // 是否设置自定义登录(问卷实名制) 0不设置 1设置
          consentRequired: this.dataObj.consentRequired, // 知情同意书 0不设置 1设置
          ifShowFooterLogo: this.dataObj.ifShowFooterLogo, // 是否显示底部logo 0不显示 1显示
          ifAllowSwitchScreen: this.dataObj.ifAllowSwitchScreen, // 是否允许切屏 0允许 1不允许
          allowSwitchScreenTimes: this.dataObj.allowSwitchScreenTimes, // 允许切屏次数
          ifAnonymous: this.dataObj.ifAnonymous, // 匿名答题开关 0=关闭,1=开启
          ifRandomOrder: this.dataObj.ifRandomOrder, // 题目随机顺序开关 0=关闭,1=开启
          ifViewContent: this.dataObj.ifViewContent, // 是否可查看填写内容 0可以 1不可以
          ifFreeAd: this.dataObj.ifFreeAd, // 是否免广告 0不免广告 1免广告
          adLimitNum: this.dataObj.adLimitNum, // 广告限制数
          isPage: this.dataObj.isPage, // 是否一页一题 0否 1是
          shareImgId: this.dataObj.shareImgId,
          shareImgUrl: this.dataObj.shareImgUrl,
          consentContent: this.dataObj.consentContent,
          customLoginSettingList: this.dataObj.customLoginSettingList, // 用户自定义登录问题列表
          ifRandomOrder: this.dataObj.ifRandomOrder, // 是否随机排序 0不设置 1设置
          ifMessageNotify: this.dataObj.ifMessageNotify, // 是否短信通知 0不设置 1设置
          ifLimitAnswerNum: this.dataObj.ifLimitAnswerNum, // 是否控制提交答案总数 0不设置 1设置
          limitAnswerNum: this.dataObj.limitAnswerNum, // 答案总数不超过
          ifRedirect: this.dataObj.ifRedirect, // 是否跳转 0不跳转 1跳转
          redirectUrl: this.dataObj.redirectUrl, // 跳转链接地址
          ifCover: this.dataObj.ifCover, // 是否封面 0不设置 1设置
          coverUrl: this.dataObj.coverUrl, // 封面图片
          moduleList: modules, // 模块列表
          buildStatus: buildStatus, // 生成状态 0保存草稿  1生成问卷
        })
          .then((res) => {
            if (res.code === 200) {
              this.$message.closeAll();
              this.$message({
                type: "success",
                message: "创建成功",
                offset: "150",
              });
              this.isNext = true;
              this.$router.replace({
                name: "MyPage",
              });
            } else {
              this.$message.closeAll();
              this.$message({
                type: "success",
                message: res.msg,
                offset: "150",
              });
            }
            if (this.loading) {
              this.loading.close();
            }
          })
          .catch((err) => {
            console.log("err", err);
            if (this.loading) {
              this.loading.close();
            }
          });
      } else {
        updateQuestionnaire({
          uuid: this.id, // 活动唯一标识
          questionnaireName:
            this.dataObj.questionnaireName.trim() === ""
              ? "问卷标题"
              : this.dataObj.questionnaireName, // 问卷名称
          questionnaireDescribe:
            this.dataObj.questionnaireDescribe.trim() === ""
              ? "感谢您抽出宝贵时间，您的回答意义重大！"
              : this.dataObj.questionnaireDescribe, // 问卷描述
          questionnaireInformation: JSON.stringify(this.infoFileList), // 问卷信息
          ifFrontPage: this.dataObj.ifFrontPage, //  是否开始答题/问卷结束设置 0不设置 1设置
          startLanguage: this.dataObj.startLanguage, // 问卷开始语
          endLanguage: this.dataObj.endLanguage, // 问卷结束语
          endImg: this.dataObj.endImg, // 问卷结束图片
          endSubtitle: this.dataObj.endSubtitle, // 问卷结束小标题
          startImg: this.dataObj.startImg, // 问卷开始图片
          startSubtitle: this.dataObj.startSubtitle, // 问卷开始小标题
          startButtonText: this.dataObj.startButtonText, // 问卷开始按钮文本
          startButtonColor: this.dataObj.startButtonColor, // 问卷开始按钮颜色
          startColor: this.dataObj.startColor, // 问卷开始主题颜色
          endColor: this.dataObj.endColor, // 问卷结束主题颜色
          startLittleImg: this.dataObj.startLittleImg, // 问卷开始小图
          endLittleImg: this.dataObj.endLittleImg, // 问卷结束小图
          startColorBegin: this.dataObj.startColorBegin,
          startColorEnd: this.dataObj.startColorEnd,
          startThemeColor: this.dataObj.startThemeColor,
          startTextColor: this.dataObj.startTextColor,
          endColorBegin: this.dataObj.endColorBegin,
          endColorEnd: this.dataObj.endColorEnd,
          endThemeColor: this.dataObj.endThemeColor,
          endTextColor: this.dataObj.endTextColor,
          ifOneChance: this.dataObj.ifOneChance, // 每人只能回答一次(仅限小程序生效) 0不设置 1设置
          ifShowCreator: this.dataObj.ifShowCreator, // 显示创建者 0不设置 1设置
          ifShowParticipation: this.dataObj.ifShowParticipation, // 显示参与人数 0不设置 1设置
          ifShowCreateTime: this.dataObj.ifShowCreateTime, // 显示创建时间 0不设置 1设置
          ifRecyclingReminder: this.dataObj.ifRecyclingReminder, // 问卷回收题提醒 0不设置 1设置
          themeId: this.dataObj.themeId, // 主题id
          yzTheme: this.dataObj.yzTheme, // 主题数据
          ifForever: this.dataObj.ifForever, // 问卷是否永久有效 0不设置 1设置,
          ifShare: this.dataObj.ifShare, // 是否分享 0不设置 1设置
          creatorName: this.dataObj.creatorName, // 创建者名称
          startTime: startTime === 0 || startTime === "" ? null : startTime, // 问卷开始时间
          endTime: endTime === 0 || endTime === "" ? null : endTime, // 问卷结束时间
          ifCustomLogin: this.dataObj.ifCustomLogin, // 是否设置自定义登录(问卷实名制) 0不设置 1设置
          consentRequired: this.dataObj.consentRequired, // 知情同意书 0不设置 1设置
          ifShowFooterLogo: this.dataObj.ifShowFooterLogo, // 是否显示底部logo 0不显示 1显示
          ifAllowSwitchScreen: this.dataObj.ifAllowSwitchScreen, // 是否允许切屏 0允许 1不允许
          allowSwitchScreenTimes: this.dataObj.allowSwitchScreenTimes, // 允许切屏次数
          ifAnonymous: this.dataObj.ifAnonymous, // 匿名答题开关 0=关闭,1=开启
          ifRandomOrder: this.dataObj.ifRandomOrder, // 题目随机顺序开关 0=关闭,1=开启
          ifViewContent: this.dataObj.ifViewContent, // 是否可查看填写内容 0可以 1不可以
          ifFreeAd: this.dataObj.ifFreeAd, // 是否免广告 0不免广告 1免广告
          adLimitNum: this.dataObj.adLimitNum, // 广告限制数
          isPage: this.dataObj.isPage, // 是否一页一题 0否 1是
          shareImgId: this.dataObj.shareImgId,
          shareImgUrl: this.dataObj.shareImgUrl,
          consentContent: this.dataObj.consentContent,
          customLoginSettingList: this.dataObj.customLoginSettingList, // 用户自定义登录问题列表
          updateType: this.dataObj.updateType, // 修改类型 0普通修改 1限制性修改 2完全修改 3复制问卷
          ifRandomOrder: this.dataObj.ifRandomOrder, // 是否随机排序 0不设置 1设置
          ifCover: this.dataObj.ifCover, // 是否封面 0不设置 1设置
          coverUrl: this.dataObj.coverUrl, // 封面图片
          ifMessageNotify: this.dataObj.ifMessageNotify, // 是否短信通知 0不设置 1设置
          ifLimitAnswerNum: this.dataObj.ifLimitAnswerNum, // 是否控制提交答案总数 0不设置 1设置
          limitAnswerNum: this.dataObj.limitAnswerNum, // 答案总数不超过
          ifRedirect: this.dataObj.ifRedirect, // 是否跳转 0不跳转 1跳转
          redirectUrl: this.dataObj.redirectUrl, // 跳转链接地址
          moduleList: modules, // 模块列表
          buildStatus: buildStatus, // 生成状态 0保存草稿  1生成问卷
        })
          .then((res) => {
            if (res.code === 200) {
              this.$message.closeAll();
              this.$message({
                type: "success",
                message: "保存成功",
                offset: "150",
              });
              this.isNext = true;
              this.$router.replace({
                name: "MyPage",
              });
            } else {
              this.$message.closeAll();
              this.$message({
                type: "success",
                message: res.msg,
                offset: "150",
              });
            }
            if (this.loading) {
              this.loading.close();
            }
          })
          .catch((err) => {
            console.log("err", err);
            if (this.loading) {
              this.loading.close();
            }
          });
      }
    },
    checkRequired() {
      for (let i = 0; i < this.addQuestionsList.length; i++) {
        const element = this.addQuestionsList[i];
        switch (element.type) {
          case this.QuestionType.SCQ:
            if (element.caseProblem === "") {
              this.addQuestionsList[i].caseProblem = "请选择";
            }
            break;
          case this.QuestionType.MCQ:
            if (element.caseProblem === "") {
              this.addQuestionsList[i].caseProblem = "请选择";
            }
            break;
          case this.QuestionType.SBQ:
            if (element.caseProblem === "") {
              this.addQuestionsList[i].caseProblem = "请输入";
            }
            break;
          case this.QuestionType.MBQ:
            if (element.caseProblem === "") {
              this.addQuestionsList[i].caseProblem = "请输入";
            }
            break;
          case this.QuestionType.DLQ:
            if (element.caseProblem === "") {
              this.addQuestionsList[i].caseProblem = "请选择";
            }
            break;
          case this.QuestionType.NPS:
            if (element.caseProblem === "") {
              this.addQuestionsList[i].caseProblem = "请选择";
            }
            break;
          case this.QuestionType.VOTE:
            if (element.caseProblem === "") {
              this.addQuestionsList[i].caseProblem = "请选择";
            }
            break;
          case this.QuestionType.SORT:
            if (element.caseProblem === "") {
              this.addQuestionsList[i].caseProblem = "请选择";
            }
            break;
          case this.QuestionType.REMARK:
            break;
          case this.QuestionType.SCORE:
            if (element.caseProblem === "") {
              this.addQuestionsList[i].caseProblem = "请输入";
            }
            break;
          case this.QuestionType.QA:
            if (element.caseProblem === "") {
              this.addQuestionsList[i].caseProblem = "请选择";
            }
            break;
          case this.QuestionType.WRQ:
            if (element.caseProblem === "") {
              this.addQuestionsList[i].caseProblem = "请选择";
            }
            break;
          case this.QuestionType.SRQ:
            if (element.caseProblem === "") {
              this.addQuestionsList[i].caseProblem = "请评星";
            }
            break;
          case this.QuestionType.NAME:
            if (element.caseProblem === "") {
              this.addQuestionsList[i].caseProblem = "请输入";
            }
            break;
          case this.QuestionType.GENDER:
            if (element.caseProblem === "") {
              this.addQuestionsList[i].caseProblem = "请选择";
            }
            break;
          case this.QuestionType.AGE:
            if (element.caseProblem === "") {
              this.addQuestionsList[i].caseProblem = "请选择";
            }
            break;
          case this.QuestionType.TEL:
            if (element.caseProblem === "") {
              this.addQuestionsList[i].caseProblem = "请输入";
            }
            break;
          case this.QuestionType.EMAIL:
            if (element.caseProblem === "") {
              this.addQuestionsList[i].caseProblem = "请输入";
            }
            break;
          case this.QuestionType.DATE:
            if (element.caseProblem === "") {
              this.addQuestionsList[i].caseProblem = "请选择";
            }
            break;
          case this.QuestionType.TIME:
            if (element.caseProblem === "") {
              this.addQuestionsList[i].caseProblem = "请选择";
            }
            break;
          case this.QuestionType.ADDR:
            if (element.caseProblem === "") {
              this.addQuestionsList[i].caseProblem = "请选择";
            }
            break;
          default:
            break;
        }
      }
    },
    editClick(item, index) {
      const hasEdit = this.addQuestionsList.some((item) => item.status === "0");
      if (hasEdit) {
        this.$message.closeAll();
        this.$message({
          type: "error",
          message: "请先保存当前编辑的题目",
          offset: "150",
        });
        return;
      }
      this.addQuestionsList[index].status = "0";
    },
    async queryDetail() {
      await questionnaireUpdateDetail({
        uuid: this.uuid,
      })
        .then((res) => {
          if (res.code === 200) {
            console.log("res111111111111111", res);

            this.dataObj = res.data;
            this.releaseStatus = res.data.releaseStatus;
            if (this.dataObj.themeId === "" || this.dataObj.themeId === null) {
              this.dataObj.yzTheme = {
                borderColor: "#E3E3E3",
                startColor: "#ffffff",
                endColor: "#ffffff",
                mainTitle: "默认主题",
                subTitle: "默认主题",
                mainColor: "#333333",
                subColor: "#333333",
                btnColor: "#333333",
                btnText: "提交",
                btnBg: "#ffffff",
                btnBorder: "#E3E3E3",
                themeColor: "#3A60FF",
              };
            } else {
              this.selectThemeIndex = this.themeList.findIndex(
                (item) => item.id === this.dataObj.themeId,
              );
            }
            this.themeStyle = this.dataObj.yzTheme;
            this.updateType = this.dataObj.updateType;
            this.themeData = this.dataObj.yzTheme;
            console.log("this.dataObj", this.dataObj);

            this.infoFileList = JSON.parse(
              this.dataObj.questionnaireInformation,
            );

            this.moduleList = this.dataObj.moduleList.map((item) => ({
              ...item,
              moduleContent: JSON.parse(item.moduleContent),
            }));

            console.log("this.infoFileList", this.infoFileList);

            this.queryQuestionTempList();
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    },
    async queryQuestionTempList() {
      await questionTempList({
        uuid: this.uuid, // 活动唯一标识
        predivStatus: 0,
      })
        .then((res) => {
          if (res.code === 200) {
            this.addQuestionsList = res.data;
            this.addQuestionsList.forEach((element) => {
              element.status = "1";
            });

            let pageLineIndex = 0;
            let questionIndex = 0;
            for (let i = 0; i < this.addQuestionsList.length; i++) {
              if (
                this.addQuestionsList[i].type === this.QuestionType.PageBreak
              ) {
                pageLineIndex++;
                this.addQuestionsList[i].pageLineIndex = pageLineIndex;
              } else {
                if (this.addQuestionsList[i].type !== this.QuestionType.TITLE) {
                  questionIndex++;
                  this.addQuestionsList[i].questionIndex = questionIndex;
                }
              }
            }
          }
          if (this.loading) {
            this.loading.close();
          }
        })
        .catch((err) => {
          if (this.loading) {
            this.loading.close();
          }
          console.log("err", err);
        });
    },
    themeSettingConfirmClick(e) {
      console.log("e", this.themeList[this.selectThemeIndex]);

      this.showThemeSetting = false;
      this.dataObj.themeId = this.themeList[this.selectThemeIndex].id;
      this.themeData = this.themeList[this.selectThemeIndex];
      setTimeout(() => {
        this.$message({
          type: "success",
          message: "保存成功",
          offset: "150",
        });
      }, 50);
    },
    handleCoverSetting() {
      this.showCoverSetting = true;
    },
    handleLoginSetting() {
      this.showLoginSetting = true;
    },
    handleConsentRequired() {
      this.showConsentRequired = true;
    },
    handleShareImage() {
      this.showShareImage = true;
    },
    handleCustomLoginChange(e) {
      console.log("e", e);
      this.dataObj.customLoginSettingList = JSON.parse(e).info;
      this.dataObj.ifCustomLogin = JSON.parse(e).ifCustomLogin;
      this.showLoginSetting = false;
      setTimeout(() => {
        this.$message({
          type: "success",
          message: "保存成功",
          offset: "150",
        });
      }, 50);
    },
    handleStartEndChange(res) {
      console.log("res", res);
      this.dataObj.startLanguage = res.startLanguage; // 问卷开始语
      this.dataObj.endLanguage = res.endLanguage; // 问卷结束语
      this.dataObj.endImg = res.endImg; // 问卷结束图片
      this.dataObj.startImg = res.startImg; // 问卷开始图片
      this.dataObj.startSubtitle = res.startSubtitle; // 问卷开始小标题
      this.dataObj.startButtonText = res.startButtonText; // 问卷开始按钮文本
      this.dataObj.startButtonColor = res.startButtonColor; // 问卷开始按钮颜色
      this.dataObj.startColor = res.startColor; // 问卷开始主题颜色
      this.dataObj.endColor = res.endColor; // 问卷结束主题颜色
      this.dataObj.endSubtitle = res.endSubtitle; // 问卷结束小标题
      this.dataObj.ifFrontPage = res.ifFrontPage; // 是否开始答题/问卷结束设置 0不设置 1设置
      this.dataObj.startLittleImg = res.startLittleImg; // 问卷开始小图片
      this.dataObj.endLittleImg = res.endLittleImg; // 问卷结束小图片
      this.dataObj.startColorBegin = res.startColorBegin;
      this.dataObj.endColorBegin = res.endColorBegin;
      this.dataObj.startColorEnd = res.startColorEnd;
      this.dataObj.endColorEnd = res.endColorEnd;
      this.dataObj.startThemeColor = res.startThemeColor;
      this.dataObj.endThemeColor = res.endThemeColor;
      this.dataObj.startTextColor = res.startTextColor;
      this.dataObj.endTextColor = res.endTextColor;
      this.showCoverSetting = false;
      setTimeout(() => {
        this.$message({
          type: "success",
          message: "保存成功",
          offset: "150",
        });
      }, 50);
    },

    saveQuestionClick(e) {
      console.log("saveQuestionClick", e);
      this.loading = this.$loading({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      var data = JSON.parse(e).data;
      data.uuid = this.uuid;

      // 检查localStorage中是否存在openId
      const openId = localStorage.getItem("openId");
      if (
        openId == null ||
        openId == "null" ||
        openId == undefined ||
        openId == ""
      ) {
        if (this.wxBindDialogVisible == false) {
          // 显示微信绑定弹窗
          this.wxBindDialogVisible = true;
          // 获取二维码
          this.getWxQrCode();
        }

        return;
      }

      saveQuestion(data)
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.queryQuestionTempList();
          } else {
            this.$message({
              type: "error",
              message: res.msg,
              offset: "150",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    updateQuestionClick(e) {
      this.addQuestionsList[JSON.parse(e).index] = JSON.parse(e).data;
    },
    cancelQuestionClick(e) {
      console.log("cancelQuestionClick", e);
    },
    logicSettingClick(item, index) {
      console.log("logicSettingClick", item, index);
    },
    againModifyCofim() {
		updateQuestionnaireSetting({
			updateType: this.againModifyActive+1,
			uuid: this.uuid
		}).then((res) => {
			console.log('againModifyRes', res)
			if(res.code === 200) {
				this.againModifyShow = false;
				this.againModifyState = true;
				this.queryDetail()
			}
		  })
		  .catch((err) => {
			console.log(err);
		  });
	},
	handleMaskClick(index) {
      console.log("handleMaskClick", index);
      // const hasEdit = this.addQuestionsList.some((item) => item.status === "0");
      // if (hasEdit) {
      //   this.$message.closeAll();
      //   this.$message({
      //     type: "error",
      //     message: "请先保存当前编辑的题目",
      //     offset: "150",
      //   });
      //   return;
      // }
	  console.log('dataObj', this.dataObj.updateQuestionStatus)
	  if(this.dataObj.updateQuestionStatus === 1 && !this.againModifyState) {
		  this.againModifyShow = true;
		  return
	  }
	  
      this.$message.closeAll();
      const activeItem = this.addQuestionsList.find(
        (item) => item.status === "0",
      );
      console.log("activeItem=====handleMaskClick", activeItem);
      if (
        activeItem !== undefined &&
        activeItem !== null &&
        activeItem !== {}
      ) {
        const checkItem = this.checkQuestion(activeItem);
        if (checkItem) {
          checkItem.uuid = this.uuid;

          // 检查localStorage中是否存在openId
          const openId = localStorage.getItem("openId");
          if (
            openId == null ||
            openId == "null" ||
            openId == undefined ||
            openId == ""
          ) {
            if (this.wxBindDialogVisible == false) {
              // 显示微信绑定弹窗
              this.wxBindDialogVisible = true;
              // 获取二维码
              this.getWxQrCode();
            }

            return;
          }

          saveQuestion(checkItem)
            .then((res) => {
              console.log(res);
              if (res.code == 200) {
                // this.queryQuestionTempList();
                activeItem.status = "1";
                this.$forceUpdate();
              } else {
                this.$message({
                  type: "error",
                  message: res.msg,
                  offset: "150",
                });
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      }
      this.addQuestionsList[index].status = "0";
    },
    handleOperateClick(e) {
      console.log("handleOperateClick", e);
      const type = JSON.parse(e).type;
      const index = JSON.parse(e).index;
      switch (type) {
        case 1:
          break;
        case 2:
          this.upClick(index);
          break;
        case 3:
          this.downClick(index);
          break;
        case 4:
          this.deleteClick(this.addQuestionsList[index], index);
          break;
        default:
          break;
      }
    },
    deleteClick(item, index) {
      console.log(item, index, "oe12oe021ei021ei120");
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (this.addQuestionsList[index].id) {
            setQuestion({
              setType: "delete",
              id: this.addQuestionsList[index].id,
            })
              .then((res) => {
                if (res.code === 200) {
                  this.$message.closeAll();
                  this.$message({
                    type: "success",
                    offset: "150",
                    message: "删除成功!",
                  });
                  this.addQuestionsList.splice(index, 1);
                  // this.queryQuestionTempList()
                } else {
                  this.$message.closeAll();
                  this.$message({
                    type: "error",
                    message: res.msg,
                    offset: "150",
                  });
                }
              })
              .catch((err) => {
                console.log("err", err);
              });
          } else {
            this.addQuestionsList.splice(index, 1);
            this.$message.closeAll();
            this.$message({
              type: "success",
              offset: "150",
              message: "删除成功!",
            });
          }
        })
        .catch(() => {});
    },
    upClick(index) {
      // const hasEdit = this.addQuestionsList.some((item) => item.status === "0");
      // if (hasEdit) {
      //   this.$message.closeAll();
      //   this.$message({
      //     type: "error",
      //     message: "请先保存当前编辑的题目",
      //     offset: "150",
      //   });
      //   return;
      // }
      if (this.addQuestionsList[index].id) {
        if (index == 0) {
          this.$message.closeAll();
          this.$message({
            type: "error",
            message: "已经是第一条了",
            offset: "150",
          });
        } else {
          this.loading = this.$loading({
            lock: true,
            text: "加载中...",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          setQuestion({
            setType: "up",
            id: this.addQuestionsList[index].id,
          })
            .then((res) => {
              if (res.code === 200) {
                this.queryQuestionTempList();
              } else {
                if (this.loading) {
                  this.loading.close();
                }
                this.$message.closeAll();
                this.$message({
                  type: "success",
                  message: res.msg,
                  offset: "150",
                });
              }
            })
            .catch((err) => {
              if (this.loading) {
                this.loading.close();
              }
              console.log("err", err);
            });
        }
      } else {
        this.$message.closeAll();
        this.$message({
          type: "error",
          message: "请先保存",
          offset: "150",
        });
      }
    },
    downClick(index) {
      // const hasEdit = this.addQuestionsList.some((item) => item.status === "0");
      // if (hasEdit) {
      //   this.$message.closeAll();
      //   this.$message({
      //     type: "error",
      //     message: "请先保存当前编辑的题目",
      //     offset: "150",
      //   });
      //   return;
      // }
      if (this.addQuestionsList[index].id) {
        if (index == this.addQuestionsList.length - 1) {
          this.$message.closeAll();
          this.$message({
            type: "error",
            message: "已经是最后一条了",
            offset: "150",
          });
        } else {
          this.loading = this.$loading({
            lock: true,
            text: "加载中...",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          setQuestion({
            setType: "down",
            id: this.addQuestionsList[index].id,
          })
            .then((res) => {
              if (res.code === 200) {
                this.queryQuestionTempList();
              } else {
                if (this.loading) {
                  this.loading.close();
                }
                this.$message.closeAll();
                this.$message({
                  type: "success",
                  message: res.msg,
                  offset: "150",
                });
              }
            })
            .catch((err) => {
              if (this.loading) {
                this.loading.close();
              }
              console.log("err", err);
            });
        }
      } else {
        this.$message.closeAll();
        this.$message({
          type: "error",
          message: "请先保存",
          offset: "150",
        });
      }
    },
    handleLogicIntercept(type) {
      if (type === "isPage") {
        this.$message({
          type: "error",
          message: "您已设置一页一题，将无法设置逻辑跳转！",
          offset: "150",
        });
      }
      if (type === "ifRandomOrder") {
        this.$message({
          type: "error",
          message: "您已设置题目顺序随机，将无法设置逻辑跳转！",
          offset: "150",
        });
      }
    },
    handleImportClick() {
      this.showDialog = true;
    },
    handleConfirmClick(rows) {
      this.loading = this.$loading({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      addQuestionToQuestionnaire({
        uuid: this.uuid,
        yzUserQuestionPoolList: rows,
      })
        .then((res) => {
          if (res.code === 200) {
            this.$message.closeAll();
            this.$message({
              type: "success",
              offset: "150",
              message: "添加成功!",
            });
            this.queryQuestionTempList();
            this.showDialog = false;
          } else {
            this.$message.closeAll();
            this.$message({
              type: "error",
              message: res.msg,
              offset: "150",
            });
          }
        })
        .finally(() => {
          if (this.loading) {
            this.loading.close();
          }
        });
      // this.addQuestionsList = [...this.addQuestionsList, ...rows];
    },
    handleImportAllClick() {
      this.$message.closeAll();
      this.queryQuestionTempList();
      this.showDialog = false;
    },
    handleUploadAdd(type) {
      this.infoFileList.push({
        type,
        urls: [],
      });
    },
    handleUploadUp(fileIndex) {
      if (fileIndex === 0) {
        this.$message.closeAll();
        this.$message({
          type: "error",
          message: "已经是第一条了",
          offset: "150",
        });
        return;
      }
      const temp = this.infoFileList[fileIndex];
      this.$set(this.infoFileList, fileIndex, this.infoFileList[fileIndex - 1]);
      this.$set(this.infoFileList, fileIndex - 1, temp);
    },
    handleUploadDown(fileIndex) {
      console.log("e1212e12e12e12e12e12e12e12");
      console.log("this.infoFileList", this.infoFileList);
      if (fileIndex === this.infoFileList.length - 1) {
        this.$message.closeAll();
        this.$message({
          type: "error",
          message: "已经是最后一条了",
          offset: "150",
        });
        return;
      }
      console.log("fileIndex去去去去去去去去去", fileIndex);
      const temp = this.infoFileList[fileIndex];
      this.$set(this.infoFileList, fileIndex, this.infoFileList[fileIndex + 1]);
      this.$set(this.infoFileList, fileIndex + 1, temp);
    },
    handleUploadDelete(fileIndex) {
      this.infoFileList.splice(fileIndex, 1);
    },
    handleSingleUploadImage(fileIndex) {
      this.uploadFileIndex = fileIndex;
      this.$refs.uploadImage.click();
    },
    handleMultipleUploadImage(fileIndex) {
      this.uploadFileIndex = fileIndex;
      this.$refs.uploadImage.click();
    },
    handleVideoUploadClick(fileIndex) {
      this.uploadFileIndex = fileIndex;
      this.$refs.uploadVideo.click();
    },
    handleImageFileChange(event) {
      console.log("event.target.files", event.target.files);
      const num = this.infoFileList[this.uploadFileIndex].urls.length;
      const type = this.infoFileList[this.uploadFileIndex].type;
      if (num + event.target.files.length > 9 && type === 1) {
        this.$message.closeAll();
        this.$message({
          type: "error",
          message: "最多上传9张图片",
          offset: "150",
        });
        return;
      }
      this.handleUploadFile(event.target.files);
    },
    handleVideoFileChange(event) {
      console.log("event.target.files", event.target.files);
      this.handleUploadFile(event.target.files);
    },
    handleUploadFile(files) {
      const formData = new FormData();
      // "file" 对应后端接收的字段名
      formData.append("uuid", this.uuid);
      for (let i = 0; i < files.length; i++) {
        formData.append("file", files[i]);
      }
      axios
        .post(baseURL + "/PCwj/file/uploads", formData, {
          headers: {
            "Content-Type": "multipart/form-data", // 必须设置
            token: localStorage.getItem("token"),
          },
        })
        .then((response) => {
          console.log("response.data.urls", response);
          if (response.data.code === 200) {
            this.$message.success("上传成功！");
            console.log(
              "dwihqet1278et1278et8127te8172",
              response.data.urls.split(","),
            );
            const urls = response.data.urls.split(",");
            if (this.infoFileList[this.uploadFileIndex].type === 1) {
              this.infoFileList[this.uploadFileIndex].urls = this.infoFileList[
                this.uploadFileIndex
              ].urls.concat(
                urls.map((item) => ({
                  url: item,
                })),
              );
            } else {
              this.infoFileList[this.uploadFileIndex].urls = urls.map(
                (item) => ({
                  url: item,
                }),
              );
            }
          } else {
            this.$message.error("上传失败！");
          }
        })
        .catch((error) => {});
    },
    handleSingleDelete(fileIndex) {
      this.infoFileList[fileIndex].urls = [];
    },
    handleMultipleDelete(fileIndex, idx) {
      this.infoFileList[fileIndex].urls.splice(idx, 1);
    },
    handleVideoDelete(fileIndex) {
      this.infoFileList[fileIndex].urls = [];
    },
    handleClickOutside() {
      console.log("this.addQuestionsList", this.addQuestionsList);
      this.$message.closeAll();
      const activeItem = this.addQuestionsList.find(
        (item) => item.status === "0",
      );
      console.log("activeItem=====handleClickOutside", activeItem);

      if (
        activeItem !== undefined &&
        activeItem !== null &&
        activeItem !== {}
      ) {
        const checkItem = this.checkQuestion(activeItem);
        if (checkItem) {
          checkItem.uuid = this.uuid;
          this.loading = this.$loading({
            lock: true,
            text: "加载中...",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });

          // 检查localStorage中是否存在openId
          const openId = localStorage.getItem("openId");
          console.log("activeItem=====handleClickOutside======openId", openId);
          if (
            openId == null ||
            openId == "null" ||
            openId == undefined ||
            openId == ""
          ) {
            if (this.wxBindDialogVisible == false) {
              // 显示微信绑定弹窗
              this.wxBindDialogVisible = true;
              // 获取二维码
              this.getWxQrCode();
            }
            console.log(
              "activeItem=====handleClickOutside--------openId",
              openId,
            );
            return;
          }

          saveQuestion(checkItem)
            .then((res) => {
              console.log(res);
              if (res.code == 200) {
                this.queryQuestionTempList();
              } else {
                this.$message({
                  type: "error",
                  message: res.msg,
                  offset: "150",
                });
              }
              if (this.loading) {
                this.loading.close();
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      }
    },
    checkQuestion(obj) {
      switch (obj.type) {
        case this.QuestionType.SCQ:
          const list1 = JSON.parse(obj.chooseList).list;
          obj.caseProblem =
            obj.caseProblem === "" ? "请选择一个选项" : obj.caseProblem;
          obj.chooseList = JSON.stringify({
            list: list1.map((item, index) => {
              item.is_fill = item.is_fill ? 1 : 0;
              item.text = item.text === "" ? `选项${index + 1}` : item.text;
              return item;
            }),
          });
          return obj;
        case this.QuestionType.MCQ:
          const list2 = JSON.parse(obj.chooseList).list;
          obj.caseProblem =
            obj.caseProblem === "" ? "请选择一个选项" : obj.caseProblem;
          obj.chooseList = JSON.stringify({
            list: list2.map((item, index) => {
              item.is_fill = item.is_fill ? 1 : 0;
              item.text = item.text === "" ? `选项${index + 1}` : item.text;
              return item;
            }),
            minCount: JSON.parse(obj.chooseList).minCount,
            maxCount: JSON.parse(obj.chooseList).maxCount,
          });
          return obj;
        case this.QuestionType.SBQ:
          console.log("obj1111111111111111", obj);
          if (obj.caseProblem == "") {
            this.$message({
              type: "error",
              message: "题目不能为空",
              offset: "150",
            });
            return;
          } else if (!obj.caseProblem.includes("____")) {
            this.$message({
              type: "error",
              message: "请插入填空符",
              offset: "150",
            });
            return;
          }
          return obj;
        case this.QuestionType.MBQ:
          const list3 = JSON.parse(obj.chooseList).list;
          obj.caseProblem =
            obj.caseProblem === "" ? "请填写以下内容" : obj.caseProblem;
          obj.chooseList = JSON.stringify({
            list: list3.map((item, index) => {
              item.is_fill = item.is_fill ? 1 : 0;
              item.text = item.text === "" ? "请输入" : item.text;
              return item;
            }),
          });
          return obj;
        case this.QuestionType.DLQ:
          const list4 = JSON.parse(obj.chooseList).list;
          obj.caseProblem =
            obj.caseProblem === "" ? "请选择一个选项" : obj.caseProblem;
          obj.chooseList = JSON.stringify({
            list: list4.map((item, index) => {
              item.is_fill = item.is_fill ? 1 : 0;
              item.text = item.text === "" ? `选项${index + 1}` : item.text;
              return item;
            }),
          });
          return obj;
        case this.QuestionType.NPS:
          obj.caseProblem =
            obj.caseProblem === ""
              ? "您向朋友或同事推荐我们的可能性有多大"
              : obj.caseProblem;
          return obj;
        case this.QuestionType.VOTE:
          const list5 = JSON.parse(obj.chooseList).list;
          obj.caseProblem =
            obj.caseProblem === "" ? "请选择一个选项" : obj.caseProblem;
          obj.chooseList = JSON.stringify({
            list: list5.map((item, index) => {
              item.is_fill = item.is_fill ? 1 : 0;
              item.text = item.text === "" ? `选项${index + 1}` : item.text;
              return item;
            }),
            minCount: JSON.parse(obj.chooseList).minCount,
            maxCount: JSON.parse(obj.chooseList).maxCount,
          });
          return obj;
        case this.QuestionType.SORT:
          const list6 = JSON.parse(obj.chooseList).list;
          obj.caseProblem =
            obj.caseProblem === "" ? "请给以下选项排序" : obj.caseProblem;
          obj.chooseList = JSON.stringify({
            list: list6.map((item, index) => {
              item.is_fill = item.is_fill ? 1 : 0;
              item.text = item.text === "" ? `选项${index + 1}` : item.text;
              return item;
            }),
          });
          return obj;
        case this.QuestionType.REMARK:
          obj.caseProblem =
            obj.caseProblem === ""
              ? "请阅读本项说明，然后回答问题"
              : obj.caseProblem;
          return obj;
        case this.QuestionType.SCORE:
          const list7 = JSON.parse(obj.chooseList).list;
          obj.caseProblem =
            obj.caseProblem === "" ? "请给本项打分" : obj.caseProblem;
          obj.chooseList = JSON.stringify({
            list: list7.map((item, index) => {
              item.is_fill = item.is_fill ? 1 : 0;
              item.text = item.text === "" ? `选项${index + 1}` : item.text;
              return item;
            }),
          });
          return obj;
        case this.QuestionType.QA:
          obj.caseProblem =
            obj.caseProblem === "" ? "请填写问答题目" : obj.caseProblem;
          return obj;
        case this.QuestionType.WRQ:
          const list8 = JSON.parse(obj.chooseList).list;
          obj.caseProblem =
            obj.caseProblem === "" ? "请给本项打分" : obj.caseProblem;
          obj.chooseList = JSON.stringify({
            list: list8.map((item, index) => {
              item.is_fill = item.is_fill ? 1 : 0;
              item.text = item.text === "" ? `打分项${index + 1}` : item.text;
              return item;
            }),
          });
          return obj;
        case this.QuestionType.SRQ:
          const list9 = JSON.parse(obj.chooseList).list;
          obj.caseProblem =
            obj.caseProblem === "" ? "请给本项打分" : obj.caseProblem;
          obj.chooseList = JSON.stringify({
            list: list9.map((item, index) => {
              item.is_fill = item.is_fill ? 1 : 0;
              item.text = item.text === "" ? `打分项${index + 1}` : item.text;
              return item;
            }),
          });
          return obj;
        case this.QuestionType.NAME:
          obj.caseProblem = obj.caseProblem === "" ? "姓名" : obj.caseProblem;
          return obj;
        case this.QuestionType.GENDER:
          const list10 = JSON.parse(obj.chooseList).list;
          obj.caseProblem = obj.caseProblem === "" ? "性别" : obj.caseProblem;
          obj.chooseList = JSON.stringify({
            list: list10.map((item, index) => {
              item.is_fill = item.is_fill ? 1 : 0;
              item.text = item.text === "" ? `选项${index + 1}` : item.text;
              return item;
            }),
          });
          return obj;
        case this.QuestionType.AGE:
          const list11 = JSON.parse(obj.chooseList).list;
          obj.caseProblem =
            obj.caseProblem === "" ? "您的年龄是" : obj.caseProblem;
          obj.chooseList = JSON.stringify({
            list: list11.map((item, index) => {
              item.is_fill = item.is_fill ? 1 : 0;
              item.text = item.text === "" ? `选项${index + 1}` : item.text;
              return item;
            }),
          });
          return obj;
        case this.QuestionType.TEL:
          obj.caseProblem = obj.caseProblem === "" ? "手机号" : obj.caseProblem;
          return obj;
        case this.QuestionType.EMAIL:
          obj.caseProblem = obj.caseProblem === "" ? "邮箱" : obj.caseProblem;
          return obj;
        case this.QuestionType.DATE:
          obj.caseProblem = obj.caseProblem === "" ? "日期" : obj.caseProblem;
          return obj;
        case this.QuestionType.TIME:
          obj.caseProblem = obj.caseProblem === "" ? "时间" : obj.caseProblem;
          return obj;
        case this.QuestionType.ADDR:
          obj.caseProblem = obj.caseProblem === "" ? "地址" : obj.caseProblem;
          return obj;
        case this.QuestionType.IMAGE:
          obj.caseProblem =
            obj.caseProblem === "" ? "上传图片回答问题" : obj.caseProblem;
          return obj;
        case this.QuestionType.MaxDiff:
          obj.caseProblem =
            obj.caseProblem === "" ? "请输入题目" : obj.caseProblem;
          return obj;
        case this.QuestionType.UploadFile:
          obj.caseProblem =
            obj.caseProblem === "" ? "请上传文件" : obj.caseProblem;
          return obj;
        case this.QuestionType.DownloadFile:
          obj.caseProblem =
            obj.caseProblem === "" ? "请输入题目说明" : obj.caseProblem;
          return obj;
        case this.QuestionType.CASCADER:
          obj.caseProblem =
            obj.caseProblem === "" ? "请输入题目说明" : obj.caseProblem;
          return obj;
        case this.QuestionType.BDQ:
          obj.caseProblem =
            obj.caseProblem === "" ? "请选择出生日期" : obj.caseProblem;
          return obj;
        case this.QuestionType.IDQ:
          obj.caseProblem =
            obj.caseProblem === "" ? "请输入身份证号" : obj.caseProblem;
          return obj;
        case this.QuestionType.ELQ:
          obj.caseProblem =
            obj.caseProblem === ""
              ? "您的最高学历() 包括在读是？"
              : obj.caseProblem;
          return obj;
        case this.QuestionType.WX:
          obj.caseProblem =
            obj.caseProblem === "" ? "请填写微信号" : obj.caseProblem;
          return obj;
        case this.QuestionType.MatrixSCQ:
        case this.QuestionType.MatrixMCQ:
          console.log("矩阵题[][][][][][][][][][][]", obj);
          const percentageTitles = ["满意", "不满意", "中立"];
          obj.caseProblem =
            obj.caseProblem.trim() === "" ? "请输入标题" : obj.caseProblem;
          obj.chooseList = JSON.stringify({
            list: JSON.parse(obj.chooseList).list.map((temp, idx) => {
              return {
                ...temp,
                context:
                  temp.context === "" ? "标题" + (idx + 1) : temp.context,
              };
            }),
            verticalNum: JSON.parse(obj.chooseList).percentageTitle.split(",")
              .length,
            percentageTitle: JSON.parse(obj.chooseList)
              .percentageTitle.split(",")
              .map((title, titIdx) => {
                return title.trim() === "" ? percentageTitles[titIdx] : title;
              })
              .slice(0, parseInt(JSON.parse(obj.chooseList).verticalNum) || 3)
              .join(","), //竖列标题
            horizontalTitle:
              JSON.parse(obj.chooseList).horizontalTitle === ""
                ? "横标题"
                : JSON.parse(obj.chooseList).horizontalTitle,
          });
          return obj;
        case this.QuestionType.ImageSCQ:
          const imageScqEmpty = JSON.parse(obj.chooseList).list.some(
            (temp) => temp.img_path === "",
          );
          if (imageScqEmpty) {
            this.$message.error("请上传图片");
            return null;
          }
          return {
            ...obj,
            caseProblem:
              obj.caseProblem.trim() === "" ? "请选择" : obj.caseProblem,
            chooseList: JSON.stringify({
              list: JSON.parse(obj.chooseList).list.map((temp, idx) => {
                return {
                  ...temp,
                  text: temp.text === "" ? "选项" + (idx + 1) : temp.text,
                  context:
                    temp.context === "" ? "说明（限制24字）" : temp.context,
                };
              }),
            }),
          };
        case this.QuestionType.ImageMCQ:
          const imageMcqEmpty = JSON.parse(obj.chooseList).list.some(
            (temp) => temp.img_path === "",
          );
          if (imageMcqEmpty) {
            this.$message.error("请上传图片");
            return null;
          }
          return {
            ...obj,
            caseProblem:
              obj.caseProblem.trim() === "" ? "请选择" : obj.caseProblem,
            chooseList: JSON.stringify({
              list: JSON.parse(obj.chooseList).list.map((temp, idx) => {
                return {
                  ...temp,
                  text: temp.text === "" ? "选项" + (idx + 1) : temp.text,
                  context:
                    temp.context === "" ? "说明（限制24字）" : temp.context,
                };
              }),
              maxCount: JSON.parse(obj.chooseList).maxCount,
              minCount: JSON.parse(obj.chooseList).minCount,
              isCountMust: JSON.parse(obj.chooseList).isCountMust,
              isCountSwitch: JSON.parse(obj.chooseList).isCountSwitch,
            }),
          };
        case this.QuestionType.Signature:
          return {
            ...obj,
            caseProblem:
              obj.caseProblem.trim() === ""
                ? "请输入题目标题"
                : obj.caseProblem,
          };
        case this.QuestionType.ImageOrVideo:
          const isEmpty = JSON.parse(obj.chooseList).list.some(
            (temp) => temp.url === "",
          );
          if (isEmpty) {
            this.$message.error("请上传图片");
            return null;
          }
          return {
            ...obj,
            caseProblem:
              obj.caseProblem.trim() === ""
                ? "请上传图片或视频回答问题"
                : obj.caseProblem,
          };
        case this.QuestionType.TITLE:
          return {
            ...obj,
            caseProblem:
              obj.caseProblem.trim() === "" ? "（一）标题" : obj.caseProblem,
          };
        default:
          break;
      }
    },
    // 获取微信二维码
    async getWxQrCode() {
      try {
        const params = {
          // 这里添加你需要传递的参数
        };
        const response = await axios.post(
          `${process.env.API_BASE_URL}/PCwj/login`,
          params,
          {
            headers: {
              appId: this.$store.getters.getAppId,
            },
          },
        );
        if (response.data.code === 200) {
          // 将 Base64 数据转换为可以在 img 标签中使用的格式
          this.qrCodeUrl = `data:image/png;base64,${response.data.data.base64}`;
          this.loginKey = response.data.data.loginKey; // 保存 loginKey
          this.message = "";

          // 开始轮询检查登录状态
          this.pollingInterval = setInterval(async () => {
            try {
              const checkResponse = await axios.get(
                `${process.env.API_BASE_URL}/PCwj/checkLoginCode`,
                {
                  params: {
                    loginKey: this.loginKey,
                  },
                },
                {
                  headers: {
                    appId: this.$store.getters.getAppId,
                  },
                },
              );

              if (checkResponse.data.code === 200) {
                // 假设返回 code 200 且特定字段表示登录成功
                if (checkResponse.data.msg != "0") {
                  clearInterval(this.pollingInterval); // 停止轮询
                  console.log("用户已登录");

                  let arr = checkResponse.data.msg.split(",");
                  this.token = arr[1];

                  // 关闭弹窗
                  this.wxBindDialogVisible = false;

                  //绑定微信
                  const formData = new FormData();
                  formData.append("wxToken", this.token);

                  feiShuBindUser(formData).then((res) => {
                    console.log(res);
                    if (res.code == 200) {
                      // 保存token
                      localStorage.setItem("token", this.token);

                      this.message = "绑定成功";
                      // 绑定成功后，刷新页面或执行其他操作
                      setTimeout(() => {
                        window.location.reload(); // 刷新页面
                      }, 1000); // 1秒后刷新
                    }
                  });
                }
              } else if (checkResponse.data.code == 500) {
                clearInterval(this.pollingInterval); // 停止轮询
                // 使用 ref 获取 DOM 元素并修改样式
                if (this.$refs.xcxqrcode) {
                  this.$refs.xcxqrcode.style.filter = "blur(5px)";
                }
                if (this.$refs.wrpreloadbtn) {
                  this.$refs.wrpreloadbtn.style.display = "block";
                }
                this.message = "二维码已过期，请重新扫码";
              } else {
                console.error("检查登录状态失败:", checkResponse.data.msg);
              }
            } catch (error) {
              console.error("检查登录状态时出错:", error);
            }
          }, 3000); // 每 3 秒轮询一次
        } else {
          console.error("获取二维码失败:", response.data.msg);
        }
      } catch (error) {
        console.error("获取二维码失败:", error);
      }
    },
    handleSettingChange(e) {
      this.dataObj.ifFrontPage = e.ifFrontPage;
      this.dataObj.ifOneChance = e.ifOneChance;
      this.dataObj.creatorName = e.creatorName;
      this.dataObj.ifShowCreator = e.ifShowCreator;
      this.dataObj.ifShowParticipation = e.ifShowParticipation;
      this.dataObj.ifShowCreateTime = e.ifShowCreateTime;
      this.dataObj.ifRecyclingReminder = e.ifRecyclingReminder;
      this.dataObj.ifForever = e.ifForever;
      this.dataObj.ifShare = e.ifShare;
      this.dataObj.startTime = e.startTime;
      this.dataObj.endTime = e.endTime;
      this.dataObj.ifCustomLogin = e.ifCustomLogin;
      this.dataObj.customLoginSettingList = e.customLoginSettingList;
      this.dataObj.consentRequired = e.consentRequired;
      this.dataObj.consentContent = e.consentContent;
      this.dataObj.ifAnonymous = e.ifAnonymous;
      this.dataObj.ifRandomOrder = e.ifRandomOrder;
      this.dataObj.ifViewContent = e.ifViewContent;
      this.dataObj.ifFreeAd = e.ifFreeAd;
      this.dataObj.ifWechatRedPacket = e.ifWechatRedPacket;
      this.dataObj.ifAllowSwitchScreen = e.ifAllowSwitchScreen;
      this.dataObj.allowSwitchScreenTimes = e.allowSwitchScreenTimes;
      this.dataObj.isPage = e.isPage;
      this.dataObj.ifShowFooterLogo = e.ifShowFooterLogo;
      this.dataObj.ifMessageNotify = e.ifMessageNotify;
      this.dataObj.ifLimitAnswerNum = e.ifLimitAnswerNum;
      this.dataObj.limitAnswerNum = e.limitAnswerNum;
      this.dataObj.ifRedirect = e.ifRedirect;
      this.dataObj.redirectUrl = e.redirectUrl;
    },
    handleShowMessage(msg) {
      this.$message.error(msg);
    },
    handleInfoChange(e) {
      this.dataObj.questionnaireInformation = e.questionnaireInformation;
      this.dataObj.questionnaireName = e.questionnaireName;
      this.dataObj.questionnaireDescribe = e.questionnaireDescribe;
    },
  },
  beforeDestroy() {
    // 组件销毁时清除轮询
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
    }
  },
};
</script>

<style lang="scss" scoped>
.noData {
  height: 525px;
  background-color: #fff;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.noData .text {
  font-size: 14px;
  font-weight: 400;
  color: rgba(85, 90, 100, 1);
  margin-top: 30px;
}

.questionnaire_box .add_control .add_btn_list .btn_item .content {
  padding: 0;
}

.mask-div {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  z-index: 90;
}

.create_page {
  height: 100%;
  display: flex;
  justify-content: center;
}

.create_head {
  // padding: 15px 0;
  background-color: #f0f3f7;
  border-radius: 4px;
}

.bar-span {
  width: 4px;
  height: 16px;
  background: #3a60ff;
  border-radius: 0px 4px 4px 0px;
  margin-left: 2px;
}

.border-div {
  width: 100%;
  height: 0.5px;
  background-color: #e7e7e7;
}

.wx-bind-dialog {
  text-align: center;
}

.qr-code-container {
  margin: 20px 0;
}

.qr-code-container img {
  width: 200px;
  height: 200px;
  margin: 0 auto;
}

.loading {
  padding: 50px 0;
  color: #999;
}

.message {
  color: #ff4d4f;
  margin-bottom: 10px;
}

.reload-btn {
  margin-top: 10px;
}

.againModify {
	position: fixed;
	top: 0;
	left: 0;
	z-index: 99999;
	width: 100%;
	height: 100%;
	background: #00000050;
}

.againModify .content {
	width: 400px;
	// height: 344px;
	background: #ffffff;
	border-radius: 8px;
	position: absolute;
	top: 50%;
	left: 50%;
	-webkit-transform: translate(-50%, -50%);
	transform: translate(-50%, -50%);
	padding: 0 12px;
}

.againModify .content .heading {
	width: 100%;
	height: 59px;
	background-color: #ffffff;
	display: flex;
	justify-content: space-between;
	align-items: center;
	border-bottom: 1px solid #E7E7E7;
	font-size: 18px;
	font-weight: 600;
	line-height: 1;
	color: #2B2F36;
	position: relative;
}

.againModify .content .heading .icon {
	position: absolute;
	top: 50%;
	right: 0;
	transform: translate(0, -50%);
	width: 18px;
	height: 18px;
	cursor: pointer;
}

.againModify .content .heading .icon::before,
.againModify .content .heading .icon::after {
	display: block;
	content: "";
	width: 100%;
	height: 2px;
	background: #888888;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%) rotate(45deg);
}

.againModify .content .heading .icon::after {
	transform: translate(-50%, -50%) rotate(-45deg);
}

.againModify .content .list .item {
	width: 100%;
	background: #ffffff;
	border: 1px solid #dcdde0;
	border-radius: 4px;
	padding: 15px 12px;
	box-sizing: border-box;
	margin-top: 10px;
	display: flex;
	flex-direction: column;
	position: relative;
	cursor: pointer;
}

.againModify .content .list .item .title {
	font-size: 16px;
	font-weight: 500;
	text-align: left;
	color: #2b2f36;
}

.againModify .content .list .item .text {
	font-size: 14px;
	font-weight: 400;
	text-align: left;
	color: #949eaf;
	margin-top: 8px;
} 

.againModify .content .list .item.active {
	border: 1px solid #3A60FF;
}

.againModify .content .list .item.active::before {
	display: block;
	content: "";
	width: 18px;
	height: 16px;
	background: #3A60FF;
	position: absolute;
	bottom: 0;
	right: 0;
	border-radius: 12px 0 3px 0;
}

.againModify .content .list .item.active::after {
	display: block;
	content: "";
	position: absolute;
	bottom: 0px;
	right: 3px;
	width: 4px;
	height: 8px;
	border: 2px solid #fff;
	border-top: none;
	border-left: none;
	transform: translate(-50%, -50%) rotate(45deg);
}

.againModify .content .button {
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 20px auto;
	gap: 20px;
}

.againModify .content .button .item {
	width: 50%;
	height: 45px;
	line-height: 45px;
	border-radius: 45px;
	border: 1px solid #3A60FF;
	background: #ffffff;
	font-size: 17px;
	color: #3A60FF;
	font-weight: 600;
	text-align: center;
	cursor: pointer;
}

.againModify .content .button .item+.item {
	background: #3A60FF;
	color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/views/CreatePage/index.vue